var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDataUpload = function SvgDataUpload(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 5.33203C9.27885 5.33203 11.6667 4.4366 11.6667 3.33203C11.6667 2.22746 9.27885 1.33203 6.33333 1.33203C3.38781 1.33203 1 2.22746 1 3.33203C1 4.4366 3.38781 5.33203 6.33333 5.33203Z",
    stroke: "#E3AF32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.22656C3.40133 7.34656 3.84933 7.44656 4.33333 7.5199M6.33333 9.99856C3.388 9.99856 1 9.10323 1 7.99856M3 11.8932C3.40133 12.0132 3.84933 12.1132 4.33333 12.1866",
    stroke: "#E3AF32",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 14.6654C3.388 14.6654 1 13.77 1 12.6654V3.33203M11.6667 3.33203V7.9987M11.6667 11.1147L10.884 10.1234C10.4667 9.59603 10.2587 9.33203 10 9.33203C9.74133 9.33203 9.53333 9.59603 9.116 10.1234L8.33333 11.1147M10 9.39003V14.6654",
    stroke: "#E3AF32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDataUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_upload.2f66c48d5d0d3aef8b6f1d45b4bea9dc.svg";